/**
 * O CAMPO DO DEPÓSITO QUANDO NÃO HÁ DEPÓSITO. Achado dos robôs no QAS
 * (20/10/2026): a empresa ainda não tinha depósito cadastrado, a lista só
 * oferecia "Escolha o depósito", e o lançamento do movimento recusava com
 * "Escolha o depósito." — sem toast, porque nada foi gravado, e sem dizer que
 * não havia o que escolher. Em Compras, "Acrescentar item" ficava desabilitado
 * sem motivo, e o pedido seguia "0 itens · R$ 0,00".
 *
 * A lista vazia diz por que está vazia e o que fazer: quem cadastra depósito
 * (`estoque.gerir`) é levado ao botão; quem não cadastra, a quem pedir.
 */
export function opcaoVaziaDoDeposito(quantos: number, podeCadastrar: boolean): string {
  if (quantos > 0) return 'Escolha o depósito';
  return podeCadastrar
    ? 'Nenhum depósito cadastrado · cadastre em Estoque › Cadastrar depósito'
    : 'Nenhum depósito cadastrado · peça ao Almoxarifado';
}

/** A frase do campo do depósito sem escolha (p.22: diz o que fazer). */
export function faltaDoDeposito(quantos: number, podeCadastrar: boolean, escolha = 'Escolha o depósito.'): string {
  if (quantos > 0) return escolha;
  return podeCadastrar
    ? 'Não há depósito cadastrado. Cadastre um em Cadastrar depósito, no topo do Estoque, e lance de novo.'
    : 'Não há depósito cadastrado. Peça ao Almoxarifado que cadastre um em Estoque › Cadastrar depósito.';
}
